import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const discountApiService = createApi({
  reducerPath: 'discountApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/discount/'),
  endpoints: (builder) => ({
    createDiscount: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "applyDiscount",
        body: args
      })
    })
  })
})

export const {
  useCreateDiscountMutation,
} = discountApiService